import {Image, Text} from "@react-pdf/renderer";
import React from "react";

export const Icon = ({type}) => {
  const images = require.context('../../../../assets/img/icons', true);
  try {
    let img = images('./' + type.toLowerCase() + '.png');
    return (
      <Image
        style={{width: 10, height: 10, verticalAlign: 'middle', 'object-fit': 'cover', marginRight: '5px'}}
        key={type + Math.random()}
        alt={type}
        title={type}
        src={img.default}
      />
    );
  } catch (e) {
    return <Text> </Text>;
  }
};
